import { render, staticRenderFns } from "./NotHavePermission.vue?vue&type=template&id=fc659c06"
import script from "./NotHavePermission.vue?vue&type=script&lang=js"
export * from "./NotHavePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports